













































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { EButtonType } from '@getaccept/lib-ui';
import { EInviteInputType } from '@signing-page/signing/types/enums/invite-input-type';
import { EModalSizes } from '@/enums/ModalSizes';
import RadioCheckbox from '@/components/RadioCheckbox.vue';
import { IInviteRecipientInfo } from '@signing-page/signing/types/invite-recipient-info';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { ERecipientRole } from '@lib-shared/recipients/types/enums/recipient-role';
import { InviteModalHelper } from '@signing-page/signing/helpers/invite-modal.helper';

@Component({
  components: {
    RadioCheckbox,
  },
  data: () => ({
    EModalSizes,
    EButtonType,
    EInviteInputType,
  }),
})
export default class InviteModal extends Vue {
  @Prop() forwarded: boolean;
  @Prop() hasSmsToSign: boolean;
  @Prop() loading: boolean;
  @Prop() recipient!: IRecipient;
  @Prop() isSigned: boolean;
  @Prop() isSigningForward: boolean;

  transferYes = false;
  transferNo = false;
  firstName = '';
  lastName = '';
  email = '';
  mobile = '';
  firstNameError = '';
  lastNameError = '';
  emailError = '';
  mobileError = '';
  transferError = '';

  get isMissingRequiredInput(): boolean {
    return (
      !!this.firstNameError ||
      !!this.lastNameError ||
      !!this.emailError ||
      !!this.mobileError ||
      !!this.transferError
    );
  }

  get allowRoleTransfer(): boolean {
    return this.recipient.role === ERecipientRole.Signer && !this.isSigned && this.isSigningForward;
  }

  get roleTransferSelected(): boolean {
    return this.transferYes || this.transferNo;
  }

  updateInput(inputType: EInviteInputType) {
    if (!this.isMissingRequiredInput) {
      return;
    }
    switch (inputType) {
      case EInviteInputType.FirstName:
        this.firstNameError = '';
        break;
      case EInviteInputType.LastName:
        this.lastNameError = '';
        break;
      case EInviteInputType.Email:
        this.emailError = '';
        break;
      case EInviteInputType.Mobile:
        this.mobileError = '';
        break;
    }
  }

  handleCheckboxClick(isTransferring: boolean) {
    this.transferError = '';
    if (isTransferring) {
      this.transferYes = true;
      this.transferNo = false;
    } else {
      this.transferYes = false;
      this.transferNo = true;
    }
  }

  handleInvite() {
    this.setErrorMessages();
    if (this.isMissingRequiredInput) {
      return;
    }
    const recipientInfo: IInviteRecipientInfo = {
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      mobile: this.mobile,
      transferSignature: this.transferYes,
    };
    this.$emit('invite', recipientInfo);
  }

  setErrorMessages() {
    this.firstNameError = InviteModalHelper.validateName('first', this.firstName);
    this.lastNameError = InviteModalHelper.validateName('last', this.lastName);
    this.emailError = InviteModalHelper.validateEmail(this.email);
    this.mobileError = InviteModalHelper.validateMobile(this.mobile, this.hasSmsToSign);
    this.transferError = InviteModalHelper.validateTransfer(
      this.allowRoleTransfer,
      this.roleTransferSelected
    );
  }

  handleClose() {
    this.$emit('close');
  }
}
